import { cva, VariantProps } from 'class-variance-authority';

export const input = cva(
  [
    'peer',
    'focus:ring-0',
    'outline-0',
    'text-base',
    'font-medium',
    'absolute',
    'flex-1',
    'pt-5',
    'inline-flex',
    'flex-row',
    'items-center',
  ],
  {
    variants: {
      disabled: {
        true: ['text-neutral-500', 'bg-transparent', 'border-neutral-400'],
        false: ['text-inherit', 'border-neutral-700'],
      },
    },
  }
);

export const inputWrapper = cva([
  'peer',
  'flex-1',
  'pt-5',
  'inline-flex',
  'flex-row',
  'items-center',
]);

export const label = cva(['peer', 'w-full']);

export const fileUploadButton = cva([
  'mr-2',
  'hover:bg-primary-100',
  'focus:bg-primary-100',
  'active:bg-primary-100',
]);

export const adornment = cva([], {
  variants: {
    position: {
      left: ['pr-3'],
      right: ['mr-0', 'ml-auto', 'pl-3'],
    },
  },
});

export const group = cva(
  ['group', 'relative', 'flex-row', 'text-blue-950', 'items-end', 'flex'],
  {
    variants: {
      error: {
        true: ['border-red-400'],
        false: [],
      },
    },
  }
);

export type StyleProps = VariantProps<typeof input>;
